import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { AppInsightsContext, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { NavigationProvider, ToastProvider } from '@laerdal/life-react-components';
import posthog from 'posthog-js';
import { initAnalytics } from './services/analytics';
import { Provider } from 'react-redux';
import store from './store/store';
import { ThemeProvider } from 'styled-components';


import '@laerdal-medical/laerdal-id-sdk';
import '@laerdal-medical/ui-components';
import '@laerdal-medical/ui-components/react';
import '@laerdal-medical/ui-components/styles.css';

var reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPLICATIONINSIGHTS,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
  }
});
appInsights.loadAppInsights();

//@ts-ignore
if (!window.posthog) {
  //@ts-ignore
  window.posthog = posthog;
}

// Init immediately (anonymous-safe) so early events are not dropped
initAnalytics();

// @ts-ignore
window.supportStartTime = new Date().getTime();
// @ts-ignore
window.supportFullUrl = window.location.href;



// window.laerdal?.auth?.init({
//   type: 'gigya',
//   apiKey: import.meta.env.REACT_APP_GIGYA_API_KEY,
//   appName: 'Help center',
// });


window.laerdal?.auth?.init({
  type: 'auth0',
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    scope: 'openid profile email',
    redirect_uri: window.location.origin + '/login/callback'
  },
});

// Patch getProviderType for @laerdal-medical/ui-components navigation
if (window.laerdal?.auth && !window.laerdal.auth.getProviderType) {
  window.laerdal.auth.getProviderType = () => 'auth0';
}


const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={{}}>
        <ToastProvider>
          <AppInsightsContext.Provider value={reactPlugin}>
            <NavigationProvider>
              <>
                {/* TODO: Restore global nav when @laerdal/navigation is fixed */}
                {/* TODO: Also, verify if it is required */}
                {/* <GlobalNav
                  ref={(globalNav: GlobalNav) => {
                    window.globalNav = globalNav;
                    window.globalNav?.initialize({
                      env: process.env.REACT_APP_SWITCHER_ENV,
                      canSwitchOrganization: false,
                    });
                  }}
                /> */}
                <App />
              </>
            </NavigationProvider>
          </AppInsightsContext.Provider>
        </ToastProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);

